// extracted by mini-css-extract-plugin
export default {"messages":"Bulkmessage_messages__kG1Ob","messages_content":"Bulkmessage_messages_content__JRlbJ","header":"Bulkmessage_header__uNE-h","form":"Bulkmessage_form__v4OTj"};